<template>
    <div v-loading="loading">
        <div class="bg-white rounded-xl px-3 py-4">
            <h2 class="text-xl font-[500] mb-3">Booking Summary</h2>
            <div class="top_details">
                <div class="flex w-auto gap-2 mb-3">
                    <div class="w-12 bg-gray-100 rounded-2xl justify-center items-center inline-flex"><img
                            src="./icons/ship-ref.svg" class="w-7 h-7 mt-1 object-contain" /></div>
                    <div>
                        <span class=" text-gray-400">SHIPPING REFERENCE</span>
                        <p><b class=" font-[500]">{{ bookingDetails.bookingSummary &&
                            bookingDetails.bookingSummary.shippingReference }}</b></p>
                    </div>
                </div>

                <div class="flex w-auto gap-2 mb-3">
                    <div class="w-12 bg-gray-100 rounded-2xl justify-center items-center inline-flex"><img
                            src="./icons/date.svg" class="w-7 h-7 mt-0 object-contain" /></div>
                    <div>
                        <span class=" text-gray-400">DATE CREATED</span>
                        <p><b class=" font-[500]">{{ bookingDetails && bookingDetails.bookingSummary &&
                            formatDate(bookingDetails?.bookingSummary?.dateCreated) }}</b></p>
                    </div>
                </div>

                <p>
                    <button :class="['order_status']"
                        :style="{ ...statusColors(bookingDetails?.bookingSummary?.status) }">
                        {{ bookingDetails.bookingSummary.status.replace(/_/g, ' ').toLowerCase() }}</button>
                </p>
            </div>
            <hr class="my-3" />

            <div class="detail_sec_wrapper">
                <div class="user_details_sec">
                    <div class="w-20 h-20">
                        <div class="w-full h-full  rounded-2xl justify-center items-center inline-flex"><img
                                class="w-full h-full rounded-full bg-gray-100" /></div>
                    </div>
                    <div>
                        <p><b class=" font-[500]">{{ bookingDetails && bookingDetails?.bookingSummary &&
                            bookingDetails?.bookingSummary?.sender?.name }}</b></p>
                        <p class=" text-gray-300">{{ bookingDetails && bookingDetails?.bookingSummary &&
                            bookingDetails?.bookingSummary?.sender?.email }}</p>
                        <p class=" text-gray-300">{{ bookingDetails && bookingDetails?.bookingSummary &&
                            bookingDetails?.bookingSummary?.sender?.phone }}</p>
                    </div>
                </div>
                <div class="user_details_sec">
                    <div class="w-12">
                        <div class="user_info_icon"><img src="./icons/location.svg" class="w-7 h-7rounded-full mt-1" />
                        </div>
                    </div>
                    <div>
                        <span class=" text-gray-400">PICK-UP LOCATION</span>
                        <p><b class=" font-[500]">{{ bookingDetails && bookingDetails?.bookingSummary &&
                            bookingDetails?.bookingSummary?.pickupLocation?.name }}</b></p>
                    </div>
                </div>
                <div class="user_details_sec">
                    <div class="w-12">
                        <div class="w-12 h-12 bg-gray-100 rounded-2xl justify-center items-center inline-flex"><img
                                src="./icons/reciever.svg" class="w-7 h-7 mt-1" /></div>
                    </div>
                    <div>
                        <span class=" text-gray-400">RECEIVER</span>
                        <p><b class=" font-[500]">Ada Orakwue</b></p>
                        <p class=" text-gray-300">{{ bookingDetails && bookingDetails?.bookingSummary &&
                            bookingDetails?.bookingSummary?.receiver?.address }}</p>
                    </div>
                </div>
            </div>
        </div>


        <div class="bg-white rounded-xl px-3 py-4 mt-4 shadow-md border border-gray-100/10 shadow-gray-100">
            <h2 class="text-xl font-[500] mb-3">Shipment Details</h2>
            <div class="flex flex-wrap gap-[1%]">
                <DetailItem title="Originating Terminal" :value="bookingDetails?.shipmentDetails?.originatingTerminal">
                    <img src="./icons/org_ter.svg" />
                </DetailItem>
                <DetailItem title="SPECIFIED SHIPMENT" :value="bookingDetails?.shipmentDetails?.specifiedShipment">
                    <img src="./icons/spec-ship.svg" />
                </DetailItem>
                <DetailItem title="SHIPPING MODE" :value="bookingDetails?.shipmentDetails?.shippingMode">
                    <img src="./icons/ship-mode.svg" />
                </DetailItem>
                <DetailItem title="PACKAGE TYPE" :value="bookingDetails?.shipmentDetails?.packageType">
                    <img src="./icons/pkg-type.svg" />
                </DetailItem>
                <DetailItem title="Destination Teminal" :value="bookingDetails?.shipmentDetails?.destinationTerminal">
                    <img src="./icons/destination-ter.svg" />
                </DetailItem>
                <DetailItem title="BOOKING CHANNEL" :value="bookingDetails?.shipmentDetails?.bookingChannel">
                    <img src="./icons/book-chl.svg" />
                </DetailItem>
                <DetailItem title="SHIPPING OPTION" :value="bookingDetails?.shipmentDetails?.shippingOption">
                    <img src="./icons/ship-opt.svg" />
                </DetailItem>
                <DetailItem title="WAYBILL NO" :value="bookingDetails?.shipmentDetails?.waybillNo">
                    <img src="./icons/waybil.svg" />
                </DetailItem>
                <DetailItem title="PACKAGE DESCRIPTION" :value="bookingDetails?.shipmentDetails?.packageDescription">
                    <img src="./icons/pkg-desc.svg" />
                </DetailItem>
                <DetailItem title="ROUTE" :value="bookingDetails?.shipmentDetails?.route">
                    <img src="./icons/route.svg" />
                </DetailItem>
                <DetailItem title="DISTANCE" :value="bookingDetails?.shipmentDetails?.distance">
                    <img src="./icons/distance.svg" />
                </DetailItem>
                <DetailItem title="ROUTE INFO" :value="bookingDetails?.shipmentDetails?.routeInfo?.routeName">
                    <img src="./icons/route.svg" />
                </DetailItem>
            </div>
        </div>

        <div class="bg-white rounded-xl px-3 py-4 mt-4 shadow-md border border-gray-100/10 shadow-gray-100">
            <h2 class="text-xl font-[500] mb-3">Package Details</h2>
            <div class="flex flex-wrap gap-[1%] mt-4">
                <DetailItem title="NUMBER OF PACKAGES" :value="bookingDetails?.packageDetails?.packages?.length">
                    <img src="./icons/pkg-num.svg" />
                </DetailItem>
                <DetailItem title="WEIGHT" :value="bookingDetails?.packageDetails?.weight">
                    <img src="./icons/weight-icon.svg" />
                </DetailItem>
                <DetailItem title="DIMENSION (LxWxH)" :value="bookingDetails?.packageDetails?.dimension">
                    <img src="./icons/dimension.svg" />
                </DetailItem>
                <DetailItem title="SPECIAL HANDLING" :value="bookingDetails?.packageDetails?.specialHandling">
                    <img src="./icons/special-hand.svg" />
                </DetailItem>
                <DetailItem title="DECLARED VALUE" :value="bookingDetails?.packageDetails?.declaredValue">
                    <img src="./icons/declared-icon.svg" />
                </DetailItem>
            </div>
        </div>

        <div class="bg-white rounded-xl px-3 py-4 mt-4 shadow-md border border-gray-100/10 shadow-gray-100">
            <h2 class="text-xl font-[500] mb-3">Payment Summary</h2>
            <div class="flex flex-wrap gap-[1%] mt-4">
                <DetailItem title="SERVICE" :value="bookingDetails?.raw?.shippingservice?.orgName">
                    <img src="./icons/service.svg" />
                </DetailItem>
                <DetailItem title="NET SHIPPING COST" :value="bookingDetails?.paymentSummary?.transaction?.breakDown?.netPrice">
                    <img src="./icons/net-cost.svg" />
                </DetailItem>
                <DetailItem title="HANDLING CHARGES" :value="bookingDetails?.paymentSummary?.transaction?.breakDown?.handlingCharges">
                    <img src="./icons/handle-charge.svg" />
                </DetailItem>
                <DetailItem title="INSURANCE" :value="bookingDetails?.paymentSummary?.transaction?.breakDown?.insuranceFee">
                    <img src="./icons/insurance.svg" />
                </DetailItem>
                <DetailItem title="RETURN SHIPPING COST" :value="bookingDetails?.paymentSummary?.returnShippingCost || 'N/A'">
                    <img src="./icons/return-ship.svg" />
                </DetailItem>
                <DetailItem title="TOTAL" :value="bookingDetails?.paymentSummary?.total">
                    <img src="./icons/total-price.svg" />
                </DetailItem>
                <DetailItem title="PROMO CODE" value="******">
                    <img src="./icons/pkg-type.svg" />
                </DetailItem>
                <DetailItem title="DISCOUNT  TOTAL" :value="bookingDetails?.paymentSummary?.transaction?.discountedEarning">
                    <img src="./icons/dis-total.svg" />
                </DetailItem>
                <DetailItem title="Tax/VAT " :value="bookingDetails?.paymentSummary?.transaction?.breakDown?.vat">
                    <img src="./icons/tax-vat.svg" />
                </DetailItem>
                <DetailItem title="PAYMENT DUE" :value="(bookingDetails?.paymentSummary?.transaction?.breakDown?.totalCost - bookingDetails?.paymentSummary?.transaction?.amount_paid)">
                    <img src="./icons/paydue.svg" />
                </DetailItem>
            </div>
        </div>
    </div>
</template>

<script>
import DetailItem from "./modules/detail-item.vue";
import moment from "moment";

export default {
    props: {
        selecetedActionShipment: {}
    },
    components: {
        DetailItem
    },
    mounted() {
        this.getConsolidationShipmentDetails()
    },
    data() {
        return {
            bookingDetails: {},
            loading: false
        }
    },
    methods: {
        formatDate(date) {
            return date ? moment(date).format("DD/MM/YYYY") : "N/A";
        },
        async getConsolidationShipmentDetails() {
            this.loading = true;
            try {
                let response = await this.$_getConsolidationShippingId("04b39ab4-a16a-4b4a-bb8f-3a63303a1280" || this.$route?.params?.id || this.selecetedActionShipment?.id);
                this.bookingDetails = response?.data?.data;
            } catch (error) {
                this.handleError(error);
            } finally {
                this.loading = false;
            }
        },
        statusColors(status) {
            const opac = "25";
            switch (status) {
                case "pending_loading":
                    return { color: "#FFA600", backgroundColor: "#FFA60030" };
                case "loading":
                    return { color: "#09B78A", backgroundColor: "#09B78A" + opac };
                case "loading_complete":
                    return { color: "#09B78A", backgroundColor: "#09B78A" + opac };
                case "dispatched_for_delivery":
                    return { color: "#09B78A", backgroundColor: "#09B78A" + opac };
                case "on-hold":
                    return { color: "#FFA600", backgroundColor: "#FFA60030" };
                case "consolidated":
                    return { color: "#FFA600", backgroundColor: "#FFA60030" };
                case "pending":
                    return { color: "#FFA600", backgroundColor: "#FFA60030" };
                case "ready_for_dispatch":
                    return { color: "#000000", backgroundColor: "#000000" + opac };
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.order_status {
    @apply text-xs w-[auto] whitespace-nowrap capitalize text-ellipsis overflow-hidden rounded-2xl py-2 px-4
}

.user_details_sec {
    @apply flex w-full sm:w-[49%] md:w-[32.3333333%] mb-3 gap-4;

    div {
        @apply text-[14.5px]
    }
}

.detail_sec_wrapper {
    @apply flex flex-wrap gap-[1%] items-center
}

.user_info_icon {
    @apply w-12 h-12 bg-primary-green/15 rounded-2xl justify-center items-center inline-flex
}

.top_details {
    @apply flex flex-wrap gap-6 items-center text-[14.5px]
}
</style>